import SpeedBox from "./SpeedBox";

export default SpeedBox;
export { SpeedBox };
